<section id="auditoria" class="folha-back">
  <div class="folha-auditoria">
    <h1>Auditoria BolCó 2026</h1>
    <p>
      Para esta copa a dinâmica da auditoria foi remodelada para deixar mais seguro o processo. A ideia é utilizar um
      <em>blockchain</em> para gravar os palpites no minuto inicial da partida para evitar que alguém altere os palpites
      depois.
    </p>
    <p>
      De maneira simples, o blockchain é um sistema que permite rastrear tudo que é inserida nela, desde transações
      financeiras, como por exemplo Bitcoin, Litecoin, etc, bem como qualquer informação que deseja manter a
      rastreabilidade, temporalidade e imutabilidade. Para garantir essas características, os código inseridos ficam
      conectadas entre eles – como blocos de dados que formam uma corrente – daí o nome. Caso queira saber mais, existem
      alguns artigos simples, como
      <a href="https://blog.nubank.com.br/o-que-e-blockchain/">uma explicação simples da Nubank</a> ou da
      <a href="https://exame.com/future-of-money/como-funciona-a-tecnologia-blockchain/">revista Exame</a>.
    </p>
    <hr />
  </div>
</section>
